function editSelect(){
  var engFirst = true;

  if ($("#google_translate_element select option").eq(0).text() === "ENG"){
    engFirst = false;
  }

  $('#google_translate_element select').addClass("langSelect");
  $('#google_translate_element select').parent().siblings().remove();
  $("#google_translate_element select option").remove();

  if (engFirst){
    $('#google_translate_element select').append('<option value="en">ENG</option>');
    $('#google_translate_element select').append('<option value="fr">FRE</option>');
  }
  else{
    $('#google_translate_element select').append('<option value="fr">FRE</option>');
    $('#google_translate_element select').append('<option value="en">ENG</option>');
  }

  $("#google_translate_element div:contains('Powered by')").contents().filter(function(){
    return this.nodeType === 3;
  }).wrap("<label></label>");

  $("#google_translate_element label").remove();
}

$(document).on("DOMNodeInserted" , "#google_translate_element select", function() {
  if ($("#google_translate_element select option").length == 109){
    editSelect();
    $(".goog-te-banner-frame").remove();
    $("body").css("top", "0px");
  }
});

function googleTranslateElementInit() {
  new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
}


$(document).ready(function(){


  $('.collabSlider').not('.slick-initialized').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 4,
    prevArrow: "<div class = 'prevArrow'><i class='far fa-chevron-left'></i></div>",
    nextArrow: "<div class = 'nextArrow'><i class='far fa-chevron-right'></i></div>"
  });

  var dropdownCloseDelay = 180;
  var dropdownTimer = null;
  var $activeDropdown = $();
  var $activeTrigger = $();

  function clearDropdownTimer() {
    if (dropdownTimer) {
      clearTimeout(dropdownTimer);
      dropdownTimer = null;
    }
  }

  function closeActiveDropdown() {
    clearDropdownTimer();
    $(".dropdowns .navDropdown").removeClass("show");
    $("li[nav-for]").removeClass("dropdown-open");
    $activeDropdown = $();
    $activeTrigger = $();
  }

  function openDropdown($trigger, $dropdown) {
    clearDropdownTimer();

    if (!$dropdown.length) {
      return;
    }

    $(".dropdowns .navDropdown").not($dropdown).removeClass("show");
    $("li[nav-for]").not($trigger).removeClass("dropdown-open");
    $dropdown.addClass("show");
    $trigger.addClass("dropdown-open");
    $activeDropdown = $dropdown;
    $activeTrigger = $trigger;
  }

  function scheduleCloseDropdown(delay) {
    clearDropdownTimer();

    dropdownTimer = setTimeout(function() {
      closeActiveDropdown();
    }, delay || dropdownCloseDelay);
  }

  $("li[nav-for]").each(function(){
    var $trigger = $(this);
    var name = $trigger.attr("nav-for");
    var $dropdown = $(`[dropdown-for='${name}']`);
    var isBrandConceptDropdown = $dropdown.hasClass("brandConceptDropdown");

    $trigger.on("mouseenter", function() {
      openDropdown($trigger, $dropdown);
    });

    $trigger.on("mouseleave", function() {
      scheduleCloseDropdown(isBrandConceptDropdown ? 180 : dropdownCloseDelay);
    });

    if (isBrandConceptDropdown) {
      $trigger.on("click", function(e) {
        e.preventDefault();

        if ($dropdown.hasClass("show")) {
          closeActiveDropdown();
        } else {
          openDropdown($trigger, $dropdown);
        }
      });
    }

    $dropdown.on("mouseenter", function() {
      if (isBrandConceptDropdown) {
        openDropdown($trigger, $dropdown);
        return;
      }

      openDropdown($trigger, $dropdown);
    });

    $dropdown.on("mouseleave", function() {
      scheduleCloseDropdown(isBrandConceptDropdown ? 180 : dropdownCloseDelay);
    });
  });

  $(".dropdowns .navDropdown").on("mouseenter", function() {
    clearDropdownTimer();
  });

  $(".desktopNav").on("mouseleave", function() {
    scheduleCloseDropdown();
  });

  $(".desktopNav").on("mousemove", function(e) {
    var $target = $(e.target);
    var isInsideActiveTrigger = $activeTrigger.length && $target.closest("li[nav-for]").is($activeTrigger);
    var isInsideActiveDropdown = $activeDropdown.length && $target.closest(".navDropdown").is($activeDropdown);

    if ($activeDropdown.length && !isInsideActiveTrigger && !isInsideActiveDropdown) {
      scheduleCloseDropdown();
    }
  });

  $(".desktopNav .nav-list-item").not("[nav-for]").on("mouseenter", function() {
    if ($activeDropdown.length) {
      closeActiveDropdown();
    }
  });

  $(document).on("keydown", function(e) {
    if (e.key === "Escape" && $activeDropdown.length) {
      closeActiveDropdown();
    }
  });

});

(function($) {
  if (!$) {
    return;
  }

  var STORE_LOCATOR_TITLE = "Find the nearest MINISO";
  var storeLocatorObserver = null;
  var storeLocatorRaf = null;

  function isStoreLocatorPage() {
    return window.location.pathname.toLowerCase().indexOf("store-locator") !== -1;
  }

  function titleCaseLabel(text) {
    if (!text) {
      return "";
    }

    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  function enhanceClosedFilter($searchBar) {
    if (!$searchBar || !$searchBar.length) {
      return;
    }

    var $checkbox = $searchBar.find('input[type="checkbox"]').first();

    if (!$checkbox.length) {
      return;
    }

    var $row = $checkbox.closest("div");

    if (!$row.length || $row.is(".search_bar")) {
      $row = $checkbox.parent();
    }

    if (!$row.length) {
      return;
    }

    $row.addClass("miniso-store-closed-row");
    $checkbox.addClass("miniso-store-closed-checkbox");

    var textNode = null;

    Array.prototype.some.call($row[0].childNodes, function(node) {
      if (node.nodeType === 3 && $.trim(node.nodeValue).length) {
        textNode = node;
        return true;
      }

      return false;
    });

    if (textNode) {
      $(textNode).replaceWith(
        $('<span class="miniso-store-closed-label"></span>').text(
          titleCaseLabel($.trim(textNode.nodeValue))
        )
      );
    }

    $row.find("label").each(function() {
      var $label = $(this);
      var labelText = $.trim($label.text());

      if (!labelText) {
        return;
      }

      if (labelText.toLowerCase() === "closed") {
        $label
          .text(titleCaseLabel(labelText))
          .addClass("miniso-store-closed-label");
      }
    });
  }

  function reorderStoreLocatorSections() {
    var $colMain = $("#col-main.all, #col-main.show-addresses, #col-main").first();
    var $map = $("#store_map");
    var $searchBar = $(".search_bar").first();
    var $results = $("#addresses_list");
    var $mobileTitle = $(".miniso-store-mobile-title").first();

    if (!$colMain.length || !$map.length || !$searchBar.length || !$results.length) {
      return;
    }

    if (!$colMain.hasClass("miniso-store-layout-ready")) {
      $colMain.addClass("miniso-store-layout-ready");
    }

    if (
      !$colMain.children().eq(0).is($map) ||
      !$colMain.children().eq(1).is($searchBar) ||
      !$colMain.children().eq(2).is($results)
    ) {
      $colMain.prepend($results);
      $colMain.prepend($searchBar);
      $colMain.prepend($map);
    }

    if (window.innerWidth <= 1024) {
      if (!$mobileTitle.length) {
        $mobileTitle = $('<h1 class="miniso-store-mobile-title"></h1>').text(STORE_LOCATOR_TITLE);
      } else {
        $mobileTitle.text(STORE_LOCATOR_TITLE);
      }

      $colMain.prepend($mobileTitle);
    } else if ($mobileTitle.length) {
      $mobileTitle.remove();
    }
  }

  function enhanceStoreLocator() {
    if (!isStoreLocatorPage()) {
      return;
    }

    $("body").addClass("miniso-store-locator-page");

    $("#pageHeader .pageHeaderTitle").text(STORE_LOCATOR_TITLE);

    $("#store-locator-title")
      .text(STORE_LOCATOR_TITLE)
      .addClass("miniso-store-title-hidden")
      .attr("aria-hidden", "true");

    $("#address_search")
      .attr("placeholder", "City or postal code")
      .attr("aria-label", "City or postal code");

    $(".search_within_distance select").attr("aria-label", "Distance");
    $(".search_limit select").attr("aria-label", "Results");

    $("#submitBtn")
      .text("Search")
      .attr("value", "Search");

    reorderStoreLocatorSections();
    enhanceClosedFilter($(".search_bar").first());
  }

  function scheduleStoreLocatorEnhancement() {
    if (storeLocatorRaf) {
      cancelAnimationFrame(storeLocatorRaf);
    }

    storeLocatorRaf = requestAnimationFrame(function() {
      enhanceStoreLocator();
    });
  }

  $(document).ready(function() {
    if (!isStoreLocatorPage()) {
      return;
    }

    scheduleStoreLocatorEnhancement();

    if (window.MutationObserver) {
      storeLocatorObserver = new MutationObserver(function() {
        scheduleStoreLocatorEnhancement();
      });

      storeLocatorObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    $(window).on("resize", function() {
      scheduleStoreLocatorEnhancement();
    });
  });
})(window.jQuery);
